import { type PaymentMethodDetailsFragment } from '@/affiliate-dashboard/graphql';
import { Label } from '@/components/base/label';
import Section from '@/components/base/section';
import { RiseNoLabel } from '@/components/icons';
import { faWallet } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { cloneElement } from 'react';
import { useTranslation } from 'react-i18next';
import {
  type Crypto,
  cryptoDataMap,
} from '../base/payout-method/crypto-details-form';

export function PaymentMethods({
  currentMethod,
}: {
  currentMethod: PaymentMethodDetailsFragment;
}): JSX.Element {
  const { t } = useTranslation();
  const metadata: { network?: string } = JSON.parse(
    currentMethod?.paymentMethodMetadata ?? '',
  ) as { network?: string };
  const network = metadata.network ?? '';

  return (
    <div className="h-full w-full">
      <div className="flex h-full w-full flex-wrap gap-4">
        <Section
          variant="secondary"
          className="w-full text-default-gray-950 dark:text-default-gray-200"
        >
          <div className="flex h-full w-full flex-col items-start justify-between gap-4">
            <div className="flex w-full items-center justify-between">
              <div className="flex items-center gap-3">
                <Label>
                  <FontAwesomeIcon icon={faWallet} />
                </Label>
                <span>{t('wallet.paymentMethod.wallet')}</span>
              </div>
            </div>

            <div className="flex w-full flex-wrap justify-between gap-4">
              <div className="flex w-fit items-center gap-2">
                {network ? (
                  <div>
                    {cloneElement(cryptoDataMap[network as Crypto].icon, {
                      width: 40,
                      height: 40,
                    })}
                  </div>
                ) : (
                  <RiseNoLabel />
                )}
                <div className="flex flex-col gap-1">
                  <span>{currentMethod?.displayName}</span>
                  <span className="max-w-44 truncate md:max-w-none">
                    {currentMethod?.targetAddress}
                  </span>
                </div>
              </div>
              <div className="ml-auto flex w-fit justify-end">
                <div className="flex flex-col text-sm">
                  <span>{t('wallet.paymentMethod.added')}</span>
                  <span className="text-default-gray-500">
                    {currentMethod?.createdAt &&
                      format(currentMethod?.createdAt ?? '', 'dd MMM yyyy')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Section>
      </div>
    </div>
  );
}
